import React from 'react';
import PropTypes from 'prop-types';

import CateringLocationCardFulfillmentMethods from 'catering/components/Location/CateringLocationCardFulfillmentMethods';
import LocationsCard from 'components/Location/LocationsCard';

function CateringLocationCard({ locationObject, beginOrder }) {
  const locationDetail = locationObject.location;

  const distanceToAddress = locationObject.distance_to_address
    ? `${locationObject.distance_to_address} miles`
    : '';

  const doesDeliverToAddress = locationObject.does_deliver_to_address
    ? locationObject.does_deliver_to_address
    : true;

  return (
    <LocationsCard
      isCatering
      id={locationObject.id}
      name={locationDetail.name}
      distance={distanceToAddress}
      staticMapsURLs={locationDetail.google_maps_static_urls}
      description={locationObject.description}
      phoneNumber={locationDetail.phone_number}
      street={locationDetail.street}
      city={locationDetail.city}
      state={locationDetail.state}
      postalCode={locationDetail.postal_code}
      lat={locationDetail.lat}
      lng={locationDetail.lng}
      cardActions={
        <CateringLocationCardFulfillmentMethods
          beginOrder={beginOrder}
          doesDeliverToAddress={doesDeliverToAddress}
          id={locationObject.id}
          isAcceptingPickupOrders={!locationObject.is_closed_for_pickup}
          isAcceptingDeliveryOrders={!locationObject.is_closed_for_delivery}
          isClosed={locationObject.is_closed}
          slug={locationDetail.slug}
        />
      }
    />
  );
}

CateringLocationCard.propTypes = {
  locationObject: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    location: PropTypes.shape({
      name: PropTypes.string,
      lat: PropTypes.string,
      lng: PropTypes.string,
      street: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      postal_code: PropTypes.string,
      phone_number: PropTypes.string,
      google_maps_static_urls: PropTypes.object,
      slug: PropTypes.string.isRequired
    }).isRequired,
    description: PropTypes.string,
    is_closed: PropTypes.bool,
    distance_to_address: PropTypes.string,
    does_deliver_to_address: PropTypes.bool,
    is_closed_for_pickup: PropTypes.bool,
    is_closed_for_delivery: PropTypes.bool
  }),
  beginOrder: PropTypes.func.isRequired
};

export default CateringLocationCard;
